module.exports = __webpack_public_path__ + "static/img/ic-suda.125fa31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ic-suda.png
// module id = FeUD
// module chunks = 1